import { Enquiry } from '@/service';

/**
 * @class @name EnquiryStore
 * @description Exposes menu store module
 */
export default class EnquiryStore {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name fetchEnquiry
			 * @param {Object} context
			 * @param {Uuid} id
			 */
			fetchEnquiry(context, id) {
				return Enquiry.get(id);
			},

			/**
			 * @async @name fetchEnquiryList
			 * @param {Object} context
			 * @param {Object} payload
			 */
			fetchEnquiryList(context, payload) {
				return Enquiry.list(payload);
			},

			/**
			 * @async @name submitEnquiry
			 * @param {Object} context
			 * @param {Object} payload
			 */
			submitEnquiry(context, payload) {
				return Enquiry.post(payload);
			},

			/**
			 * @async @name createResponse
			 * @param {Object} context
			 * @param {Object} payload
			 */
			createResponse(context, payload) {
				return Enquiry.createResponse(payload);
			},

			/**
			 * @async @name sendUpdate
			 * @param {Object} context
			 * @param {Object} payload
			 */
			sendUpdate(context, payload) {
				return Enquiry.update(payload);
			},

			/**
			 * @async @name fetchEnquiryList
			 * @param {Object} context
			 * @param {Object} payload
			 */
			fetchFile(context, payload) {
				return Enquiry.getFile(payload);
			}
		};
	}
}
